import * as types from './types';
import Quiz from '../../../../helpers/request/quiz';

const QuizRequest = new Quiz();

export const reportSetQuizId = ({ commit, rootState }) => {
  commit(types.REPORT_SET_QUIZ_ID, rootState.box.active.quiz_id);
};

export const reportSetPage = ({ commit }, page) => {
  commit(types.REPORT_SET_PAGE, page);
};

export const reportSetDateFrom = ({ commit }, dateFrom) => {
  commit(types.REPORT_SET_DATE_FROM, dateFrom);
};

export const reportSetDateTo = ({ commit }, dateTo) => {
  commit(types.REPORT_SET_DATE_TO, dateTo);
};

export const reportSetAnswers = ({ dispatch }) => {
  dispatch('reportSetQuizId');
  dispatch('reportRequestAnswers', types.REPORT_SET_ANSWERS);
};

export const reportRequestAnswers = ({ commit, state }, mutationType) => {
  const queryString = {
    params: {
      page: state.page,
      from: state.dateFrom,
      to: state.dateTo,
    },
  };

  QuizRequest.answers(state.quizId, queryString)
    .then(response => commit(mutationType, response.data));
};

export const reportNextPage = ({ state, dispatch, commit }) => {
  commit(types.REPORT_SET_PAGE, state.page + 1);
  dispatch('reportRequestAnswers', types.REPORT_SET_ANSWERS);
};

export const reportPreviousPage = ({ state, dispatch, commit }) => {
  commit(types.REPORT_SET_PAGE, state.page - 1);
  dispatch('reportRequestAnswers', types.REPORT_SET_ANSWERS);
};

export const reportExport = ({ state, dispatch, commit }, email) => {
  commit(types.REPORT_SET_EXPORT_EMAIL, email);
  dispatch('reportSetQuizId');

  const queryString = {
    params: {
      from: state.dateFrom,
      to: state.dateTo,
    },
  };

  QuizRequest.export(state.quizId, { email }, queryString)
    .then(() => dispatch('modalOpen', 'report-export-in-progress'));
};

export const reportResetState = ({ commit }) => {
  commit(types.REPORT_RESET_STATE);
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/report/tableData/actions.js
 **/